{
  "version": 1,
  "asset_id": "51b8f704-e3fd-4443-96bf-31fdff2b21de",
  "project_id": "7580f3ab-e7a4-418d-abe6-5eb616986e51",
  "url": "/__l5e/assets-v1/51b8f704-e3fd-4443-96bf-31fdff2b21de/crystal-river-blue-shingle-roof-destination-roofing-1320w.avif",
  "r2_key": "a/v1/7580f3ab-e7a4-418d-abe6-5eb616986e51/51b8f704-e3fd-4443-96bf-31fdff2b21de/crystal-river-blue-shingle-roof-destination-roofing-1320w.avif",
  "original_filename": "crystal-river-blue-shingle-roof-destination-roofing-1320w.avif",
  "size": 65854,
  "content_type": "image/avif",
  "created_at": "2026-07-21T19:37:36Z"
}
